import * as React from 'react';
import { Spinner, Intent, Button, H4, Tooltip, H3, H2, Card, Elevation, Classes, Drawer, Position } from '@blueprintjs/core';
import { UserState } from 'app/reducers/state';
import { executeQueryPostAuth, executeQueryGetAuth, API_CHARTBACK } from 'app/utils/api';
import { KryPlayDetails } from 'app/components/KryPlayDetails';
import { each, clone } from 'lodash';
import { CoachingAudio } from 'app/components/CoachingAudio';
import * as superagent from 'superagent';

import Highcharts from 'highcharts';
import ReactHighcharts from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more';
import hcXrange from 'highcharts/modules/xrange';
import { translateKey } from 'app/utils/forms';
import { getDynamicJournalConfiguration } from 'app/utils/scores';
import TextAreaV2 from 'app/components/TextAreaV2';

const buttonTopOffset = "-15px";

highchartsMore(Highcharts);
(hcXrange)(Highcharts)

const GOOD_CUTOFF = 0.50;

function BASESCENARIOFROMNAME(scenario: string) {
    if (scenario === undefined) return 'scenario_1';

    if (scenario.includes('scenario_2')) return 'scenario_2';
    if (scenario.includes('scenario_3')) return 'scenario_3';
    if (scenario.includes('scenario_4')) return 'scenario_4';
    if (scenario.includes('scenario_5')) return 'scenario_5';

    return 'scenario_1';
}

interface Props {
    objectiveData?: any;
    gameID: string;
    user: UserState;
    needsJournal: boolean;
    menuConfig: any;
    savedPreJournal: string;
    onResume: () => void;
    onSaveJournal: (preFeedback: string, redo: boolean, simulatedData: any) => void;
};

interface State {
    loadingObjectiveData: boolean;
    objectiveData: any;
    writtenJouranl: string;
    savingJournal: boolean;
    coachingAudio: string | string[];
    showCharts: boolean;
    showScore: boolean;
    loadingCharts: boolean;
    chartData: any;
    commitmentScore: number;
    businessScore: number;
    sub1Score: number;
    sub2Score: number;
    sub3Score: number;
    opinionTooltips: any;
    tensionTooltips: any;
    loadingSimulated: boolean;
    showCoaching: boolean;
    simulatedData: any;
    efficency: number;
    isJournalVisible: boolean;
    promptData: any;
    promptInput: any;
}

export class ClassicResultsScreen extends React.Component<Props, State> {

    state: State = {
        loadingObjectiveData: true,
        objectiveData: {},
        writtenJouranl: '',
        savingJournal: false,
        coachingAudio: '',
        showCharts: true,
        showCoaching: false,
        loadingCharts: true,
        showScore: true,
        chartData: [],
        commitmentScore: 50.0,
        businessScore: 30.0,
        sub1Score: 15.0,
        sub2Score: 40.0,
        sub3Score: 32.0,
        opinionTooltips: {},
        tensionTooltips: {},
        simulatedData: {},
        loadingSimulated: true,
        efficency: 0.0,
        isJournalVisible: false,
        promptData: {},
        promptInput: {}
    }

    getPrompt = () => {
        const {
            menuConfig
        } = this.props;

        return menuConfig.postJournalTitle;
    }

    getChartData = () => {

        const {
            opinionTooltips,
            tensionTooltips
        } = this.state;

        // Inject style settings
        let dataClone = clone(this.state.chartData);

        if (dataClone['chart'] === undefined) {
            dataClone['chart'] = {};
        }

        // Inject a full page height to our results chart
        dataClone['chart']['height'] = 'auto';

        dataClone['tooltip'] = {
            formatter: function () {
                const round = this.x;
                const roundedY = Math.round(parseFloat(this.y));

                // Opinion
                if (this.color.toLowerCase() === '#00CB00'.toLowerCase()) {
                    return opinionTooltips[round.toString()];
                }

                // Tension
                if (this.color.toLowerCase() === '#FF9319'.toLowerCase()) {
                    return tensionTooltips[round.toString()];
                }

                // PI
                if (this.color.toLowerCase() === '#935730'.toLowerCase()) {
                    return '<b>Influence: ' + roundedY.toString() + '</b>';
                }

                return undefined;
            }
        }

        return dataClone;
    }

    componentDidMount() {
        superagent.
        get('assets/prompts.json')
        .end((error: any, response: any) => {
            const promptData = JSON.parse(response.text);

            let newPromptInput = {};

            if (this.props.user.classicMode === 2) {
                if (promptData && promptData.classic) {
                    for (let i = 0; i < promptData.classic.post.length; i++) {
                        const __prompt = promptData.classic.post[i];
                        newPromptInput[__prompt] = '';
                    }
                }
            }
            else {
                if (promptData && promptData.lab) {
                    for (let i = 0; i < promptData.lab.post.length; i++) {
                        const __prompt = promptData.lab.post[i];
                        newPromptInput[__prompt] = '';
                    }
                }
            }
            this.setState({
                promptData,
                promptInput: newPromptInput
            });
        });


        this.processExtraScenarios(this.props.gameID);

        window.addEventListener('resize', () => {
            try {
                // Make sure the highchart fits correctly
                Highcharts.charts.forEach(chart => chart!.reflow());
            }
            catch (e) {
                // Let this fail without disrupting the page
                console.error(e);
            }
        });

        if (this.props.user.classicMode === 2) {
            superagent.
                get(API_CHARTBACK() + '?userID=' + this.props.user.id + '&gameID=' + this.props.gameID + '&authenticationToken=' + this.props.user.authenticationToken).
                end((error: any, response: any) => {

                    const resp = JSON.parse(response.text);

                    const sub1Score = resp.er;
                    const sub2Score = resp.ci;
                    const sub3Score = resp.fi;
                    const commitmentScore = resp.commitmentScore;
                    const businessScore = (sub1Score + sub2Score + sub3Score) / 3.0;
                    const pointsOverMaxRounds = resp.pointsOverMaxRounds;

                    this.setState({
                        showCharts: false,
                        loadingCharts: false,
                        showScore: true,
                        loadingObjectiveData: false,
                        chartData: resp.chart,
                        sub1Score,
                        sub2Score,
                        sub3Score,
                        commitmentScore,
                        businessScore,
                        opinionTooltips: resp.opinionTooltips,
                        tensionTooltips: resp.tensionTooltips,
                        efficency: pointsOverMaxRounds,
                    });
                });
        }
        else {
            this.setState({
                loadingObjectiveData: true
            });

            executeQueryPostAuth("data/results/" + this.props.gameID, {}, this.props.user, (postResponse) => {
                executeQueryGetAuth("data/results/" + this.props.gameID, {}, this.props.user, (objectiveResponse) => {
                    const response = JSON.parse(objectiveResponse.text);

                    this.setState({
                        loadingObjectiveData: false,
                        objectiveData: response
                    }, () => {
                        this.processCoachingTriggers(response);

                        const {
                            menuConfig
                        } = this.props;

                        if (menuConfig.blockObjectives === true) {
                            this.setState({
                                showCharts: false
                            });
                        }
                    });
                });
            });
        }
    }

    // Do an objective simulation against all the other game types
    processExtraScenarios = (gameID: string) => {
        this.setState({
            loadingSimulated: true
        });

        superagent.
            get(API_CHARTBACK() + '?userID=' + this.props.user.id + '&gameID=' + gameID + "&authenticationToken=" + this.props.user.authenticationToken + "&baseScenario=" + BASESCENARIOFROMNAME(this.props.menuConfig.slug)).
            end((error: any, response: any) => {
                const b = JSON.parse(response.text);

                this.setState({
                    simulatedData: b,
                    loadingSimulated: false
                });
            });
    }

    // Ignoring this for now
    componentDidUpdate() {
        // if (this.props.objectiveData !== undefined) {
        //     if (isEqual(this.props.objectiveData, this.state.objectiveData) === false) {
        //         this.setState({
        //             objectiveData: this.props.objectiveData
        //         });
        //     }
        // }
    }

    getAudioConfig = () => {
        const {
            menuConfig
        } = this.props;
        /*
            Possible audio entries
            good_goal: undefined,
            bad_goal: undefined,
            neutral_goal: undefined,
            good_process: undefined,
            bad_process: undefined,
            neutral_process: undefined
        */

        if (menuConfig === undefined) return {};

        if (menuConfig['outcomeaudio'] === undefined) return {};

        return menuConfig['outcomeaudio'];
    }

    processCoachingTriggers = (objectiveData) => {
        const audioConfig = this.getAudioConfig();

        let stats = {
            outcome_total: 0,
            outcome_positive: 0,
            outcome_result: 0.0,
            process_total: 0,
            process_positive: 0,
            process_result: 0.0,
        }

        each(objectiveData.objectives, objective => {
            const categoryname = objective.category;
            const isSuccessfull = objective.result === "True" || objective.result === "true";

            if (categoryname === undefined) return;

            if (categoryname.includes("Outcome")) {
                stats.outcome_total += 1;

                if (isSuccessfull) {
                    stats.outcome_positive += 1;
                }
            }
            else {
                stats.process_total += 1;

                if (isSuccessfull) {
                    stats.process_positive += 1;
                }
            }
        });

        // Calculate our results
        stats.outcome_result = stats.outcome_positive / stats.outcome_total;
        stats.process_result = stats.process_positive / stats.process_total;

        const isOutcomeGood = (stats.outcome_result > GOOD_CUTOFF);
        const isProcessGood = (stats.process_result > GOOD_CUTOFF);

        // TODO: Process outcome as well
        const audioLocationInMap = isProcessGood ? 'good_process' : 'bad_process';
        const audioLocationInMapOutcome = isOutcomeGood ? 'good_goal' : 'bad_goal';

        let audioLocations: string[] = [];

        if (audioConfig[audioLocationInMapOutcome] !== undefined) {
            audioLocations.push(audioConfig[audioLocationInMapOutcome]);
        }

        if (audioConfig[audioLocationInMap] !== undefined) {
            audioLocations.push(audioConfig[audioLocationInMap]);
        }

        // Now add all of our "additionalAudio" pieces
        each(audioConfig['additionalAudio'], optionalAudio => {
            audioLocations.push(
                optionalAudio
            );
        });

        if (audioLocations.length > 0) {
            this.setState({
                coachingAudio: audioLocations
            });
        }
    }

    getCurrentRound = () => {
        const {
            objectiveData
        } = this.state;

        return parseInt(objectiveData['total-rounds']);
    }

    getJournalWarning = () => {
        const {
            writtenJouranl
        } = this.state;

        const wordCount = writtenJouranl.split(' ').length;

        if (wordCount > 10) return undefined;

        return 'You might want to reflect a little more.';
    }

    updateWrittenJournalFrompPrompt = (prompt, newValue) => {
        let copy = clone(this.state.writtenJouranl);

        let body = undefined;

        try {
            body = JSON.parse(copy);
        }
        catch (e) {
            body = {};
        }

        body[prompt] = newValue;

        this.setState({ writtenJouranl: JSON.stringify(body) })
    }

    getWrittenJournalFrompPrompt = (prompt) => {
        try {
            const body = JSON.parse(this.state.writtenJouranl);

            return body[prompt];
        }
        catch (e) {
            return this.state.writtenJouranl;
        }
    }

    renderDynamicJournal = (config) => {
        let sections: any[] = [];

        for (let i = 0; i < config.length; i++) {
            const {
                prompt
            } = config[i];

            const defaultValue = this.getWrittenJournalFrompPrompt(prompt);

            sections.push(
                <span style={{ width: '100%', flex: 1, alignSelf: 'center', justifyContent: 'top' }}>
                    <H4>{prompt}</H4>
                    <TextAreaV2 defaultValue={defaultValue} onChange={(event) => {
                        this.updateWrittenJournalFrompPrompt(prompt, event.target.value);
                    }} className={"journalTextArea"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2>
                </span>
            );
        }

        return <span style={{ flexShrink: 1, transition: 'all 2s' }}>
            <span style={{ position: 'relative', display: 'flex', flexDirection: 'row' }}>
                {sections}
            </span>
        </span>
    }

    renderJournal = () => {
        const dynamicConfiguration = getDynamicJournalConfiguration(this.props.user, this.props.menuConfig, false);

        if (dynamicConfiguration !== undefined) {
            return this.renderDynamicJournal(dynamicConfiguration);
        }

        return <span style={{ flexShrink: 1, transition: 'all 2s' }}>
            <span style={{ position: 'relative' }}>
                <H4>{this.getPrompt()}</H4>
                <TextAreaV2 onChange={(event) => {
                    this.setState({
                        writtenJouranl: event.target.value
                    });
                }} className={"journalTextArea"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2>
            </span>
        </span>
    }

    handleReplayButtonPress = () => {
        const {
            onResume,
            needsJournal,
            onSaveJournal
        } = this.props;

        const {
            writtenJouranl,
            simulatedData
        } = this.state;

        this.setState({
            loadingObjectiveData: true
        });

        if (needsJournal === false) {
            onResume();
            return;
        }

        onSaveJournal(writtenJouranl, true, simulatedData);
    }

    handleResumeButtonPress = () => {
        const {
            onResume,
            needsJournal,
            onSaveJournal
        } = this.props;

        const {
            writtenJouranl
        } = this.state;

        this.setState({
            loadingObjectiveData: true
        });

        if (needsJournal === false) {
            onResume();
            return;
        }

        onSaveJournal(writtenJouranl, false, undefined);
    }

    renderReadYourOriginalPlanButton = () => {
        const {
            showCharts,
            showScore,
            showCoaching
        } = this.state;

        const isRendering = (showCharts === false && showScore === false && showCoaching === false);

        return <span style={{ position: 'relative', top: isRendering ? buttonTopOffset : undefined, marginRight: '5px' }}>
            <Button onClick={() => {
                this.setState({ showCharts: false, showScore: false });
            }} style={{ lineHeight: '50px', width: '200px', height: '50px' }} intent={Intent.PRIMARY}>{translateKey('vleader.originalPlan')}</Button>
        </span>
    }

    renderScoreHappenedButton = () => {
        const {
            showScore
        } = this.state;

        return <span style={{ position: 'relative', top: showScore ? buttonTopOffset : undefined, marginRight: '5px' }}>
            <Button onClick={() => {
                this.setState({ showScore: true, showCharts: false, showCoaching: false });
            }} style={{ lineHeight: '50px', width: '200px', height: '50px' }} intent={Intent.PRIMARY}>{translateKey('vleader.yourResults')}</Button>
        </span>
    }

    renderCoachingButton = () => {
        const {
            showCoaching
        } = this.state;

        return <span style={{ position: 'relative', top: showCoaching ? buttonTopOffset : undefined, marginRight: '5px' }}>
            <Button onClick={() => {
                this.setState({ showScore: false, showCharts: false, showCoaching: true });
            }} style={{ lineHeight: '50px', width: '200px', height: '50px' }} intent={Intent.PRIMARY}>{translateKey('vleader.coaching')}</Button>
        </span>
    }

    renderReflectOnWhatHappenedButton = () => {
        const {
            showCharts
        } = this.state;

        return <span style={{ position: 'relative', top: showCharts ? buttonTopOffset : undefined, marginRight: '5px' }}>
            <Button onClick={() => {
                this.setState({ showCharts: true, showScore: false, showCoaching: false });
            }} style={{ lineHeight: '50px', width: '200px', height: '50px' }} intent={Intent.PRIMARY}>{translateKey('vleader.reflect')}</Button>
        </span>
    }

    renderResumeButton = () => {
        const {
            needsJournal,
            menuConfig
        } = this.props;

        const RESULTS_SCREEN_BUTTON_STYLE = { lineHeight: '50px', width: '150px', height: '50px' };

        const {
            writtenJouranl
        } = this.state;

        if (needsJournal === false) {
            return <Button onClick={this.handleResumeButtonPress} style={RESULTS_SCREEN_BUTTON_STYLE} intent={Intent.SUCCESS}>{translateKey('vleader.savePlay')}</Button>
        }

        const journalWarning = this.getJournalWarning();

        const redoButton = (menuConfig.blockRedo === true) ? undefined : <Tooltip content={journalWarning}>
            <Button onClick={this.handleReplayButtonPress} style={RESULTS_SCREEN_BUTTON_STYLE} disabled={writtenJouranl === ''} intent={Intent.SUCCESS}>{translateKey('vleader.saveReplay')}</Button>
        </Tooltip>;

        return <span style={{ paddingRight: '5px', paddingLeft: '10px' }}>
            <Button onClick={() => {
                this.setState({
                    isJournalVisible: true
                });
            }} style={{ lineHeight: '50px', width: '100px', height: '50px' }} intent={Intent.NONE}>Edit Journal</Button>

            {redoButton}

            <Tooltip content={journalWarning}>
                <Button onClick={this.handleResumeButtonPress} style={RESULTS_SCREEN_BUTTON_STYLE} disabled={writtenJouranl === ''} intent={Intent.SUCCESS}>{translateKey('vleader.savePlay')}</Button>
            </Tooltip>
        </span>
    }

    renderAudio = () => {
        const {
            coachingAudio,
            loadingObjectiveData
        } = this.state;

        if (loadingObjectiveData) {
            return <span></span>
        }

        if (coachingAudio === undefined || coachingAudio === '') {
            return <span></span>
        }

        return <CoachingAudio
            audioSource={coachingAudio}
            donePlaying={() => {

            }}
        />
    }

    renderPlayDetails = () => {
        const {
            menuConfig
        } = this.props;

        const {
            objectiveData
        } = this.state;

        if (menuConfig.blockObjectives === true) {
            return <span></span>
        }

        return <KryPlayDetails
            user={this.props.user}
            selectedGame={objectiveData}
            canEditJournal={false}
            inSimulator={true}
            updateJournalDataInline={(stage: string, payload: string, gameID: string) => {
                // ignore this, we aren't letting them edit in this mode
            }}
        />
    }

    getScoreBundle = () => {
        const {
            commitmentScore,
            businessScore,
            sub1Score,
            sub2Score,
            sub3Score,
            efficency
        } = this.state;

        return {
            commitmentScore,
            businessScore,
            sub1Score,
            sub2Score,
            sub3Score,
            efficency
        }
    }

    renderScoreDisplay = () => {
        let {
            commitmentScore,
            businessScore,
            sub1Score,
            sub2Score,
            sub3Score,
            efficency
        } = this.getScoreBundle();

        let showEfficencyInverse = true;

        try {
            let _num = Math.round(efficency);

            if (_num > 0) {
                if (!isNaN(_num)) {
                    showEfficencyInverse = false;
                }
            }
        }
        catch (e) {
            console.log(e);
        }

        const finalScore = (commitmentScore + businessScore) / 2.0;

        const scoreLabelStyle = { fontSize: '40px' }
        const penaltyScoreLabelStyle = { fontSize: '40px', color: '#FF7373' }

        const finalScoreTooltipContent = `( ${Math.round(businessScore)} + ${Math.round(commitmentScore)} ) ${translateKey('vleader.finalScoreTooltip')}`;
        const businessScoreTooltipContent = `( ${Math.round(sub1Score)} + ${Math.round(sub2Score)} + ${Math.round(sub3Score)} ) ${translateKey('vleader.businessScoreTooltip')}`;
        const fiScoreTooltipContent = translateKey('vleader.fiScoreTooltip');
        const ciScoreTooltipContent = translateKey('vleader.ciScoreTooltip');
        const erScoreTooltipContent = translateKey('vleader.erScoreTooltip');
        const commitmentScoreTooltipContent = translateKey('vleader.commitmentScoreTooltip');

        const finalScoreContent = <Tooltip content={finalScoreTooltipContent}>{Math.round(finalScore)}</Tooltip>
        const businessScoreContent = <Tooltip content={businessScoreTooltipContent}>{Math.round(businessScore)}</Tooltip>
        const fiScoreContent = <Tooltip content={fiScoreTooltipContent}>{Math.round(sub1Score)}</Tooltip>
        const ciScoreContent = <Tooltip content={ciScoreTooltipContent}>{Math.round(sub2Score)}</Tooltip>
        const erScoreContent = <Tooltip content={erScoreTooltipContent}>{Math.round(sub3Score)}</Tooltip>
        const commitmentScoreContent = <Tooltip content={commitmentScoreTooltipContent}>{Math.round(commitmentScore)}</Tooltip>
        const efficencyContent = <Tooltip content={"You lose a point for every round over 120 that you go."}>{Math.round(efficency)}</Tooltip>

        return <span style={{ flexGrow: 1, flexBasis: 0 }}>
            <span style={{ flexShrink: 1, transition: 'all 2s' }}>
                <span style={{ position: 'relative' }}>
                    <table className="classicScoreTable">
                        <tr><td><H2 style={{ fontSize: '60px' }}>{translateKey('vleader.yourScore')} </H2> </td><td style={scoreLabelStyle}>{finalScoreContent}</td></tr>
                        {showEfficencyInverse ? <span /> : <tr><td><H3>Efficiency Penalty</H3> </td><td style={penaltyScoreLabelStyle}>{efficencyContent}</td></tr>}
                        <tr><td><H3>{translateKey('vleader.businessScore')} </H3> </td><td style={scoreLabelStyle}>{businessScoreContent}</td></tr>
                        <tr><td><H4>{translateKey('vleader.financialImpact')} </H4> </td><td style={scoreLabelStyle}>{fiScoreContent}</td></tr>
                        <tr><td><H4>{translateKey('vleader.customerImpact')} </H4> </td><td style={scoreLabelStyle}>{ciScoreContent}</td></tr>
                        <tr><td><H4>{translateKey('vleader.employeeRetention')} </H4> </td><td style={scoreLabelStyle}>{erScoreContent}</td></tr>
                        <tr><td><H3>{translateKey('vleader.commitmentScore')} </H3> </td><td style={scoreLabelStyle}>{commitmentScoreContent}</td></tr>
                    </table>
                </span>
            </span>
        </span>
    }

    getConfigInfo = (config: string, scenario: string, name: string) => {
        let response: any = undefined;

        const lines = config.split('\n');

        for (let i = 0; i < lines.length; i++) {
            const bits = lines[i].split('\t');

            try {
                if (bits[0] === scenario) {
                    if (bits[4] === name) {
                        const difficulty = parseInt(bits[5]);
                        const score = parseInt(bits[5]);
                        const successA = bits[8];
                        const failA = bits[9];

                        response = { difficulty, score, successA, failA };
                    }
                }
            }
            catch (e) { }
        }

        return response;
    }

    getPositionedAdjectives = (_data: any[], max: number, direction: number, nameMatch: string) => {
        let data: any[] = [];

        if (nameMatch === undefined) {
            data = _data;
        }
        else {
            for (let i = 0; i < _data.length; i++) {
                const name: string = _data[i].name;

                if (name !== undefined) {
                    if (name.toLowerCase().includes(nameMatch.toLowerCase())) {
                        data.push(_data[i]);
                    }
                }
            }
        }

        if (data.length <= max) {
            let buffer2 = '';

            for (let i = 0; i < data.length; i++) {
                // Check for an and to make gramatical sense
                if (buffer2 !== '') {
                    buffer2 += ' and ';
                }

                buffer2 += data[i].adjective;
            }

            return buffer2;
        }

        let buffer = '';

        for (let i = 0; i < max; i++) {
            // Do we count from the start of the array, or the back?
            const index = direction === 1 ? i : data.length - 1 - i;

            // Check for an and to make gramatical sense
            if (buffer !== '') {
                buffer += ' and ';
            }

            buffer += data[index].adjective;
        }

        return buffer;
    }

    // Easiest, because the lowest difficulty objectives are at the top
    getTopAdjectives = (data: any, max: number, nameMatch: any) => {
        return this.getPositionedAdjectives(data, max, 1, nameMatch);
    }

    // Hardest because the highest difficulty objectives are at the bottom
    getBottomAdjectives = (data: any, max: number, nameMatch: any) => {
        return this.getPositionedAdjectives(data, max, -1, nameMatch);
    }

    getSectionFromSheet2 = (configStatement: string, x: number, y: number) => {
        const lines: any[] = configStatement.split('\n');

        if (lines.length <= y) {
            return '';
        }

        const targetLine = lines[y];
        const bits = targetLine.split('\t');

        if (bits.length <= x) {
            return '';
        }

        return bits[x];
    }

    convertScenarioToX = (scenarioName: string) => {
        const scenario = scenarioName.toLowerCase();

        if (scenario === 'scenario_1_a1') return 1;
        if (scenario === 'scenario_1_a2') return 2;
        if (scenario === 'scenario_1_a3') return 3;

        // Fallback to directive if we can't figure it out
        return 1;
    }

    convertScenarioToStyle = (scenarioName: string) => {
        const scenario = scenarioName.toLowerCase();

        if (scenario === 'scenario_1_a1') return 'Directive';
        if (scenario === 'scenario_1_a2') return 'Delegative';
        if (scenario === 'scenario_1_a3') return 'Participative';

        // Fallback to directive if we can't figure it out
        return 'Directive';
    }

    renderSimulatedSection = (data: any, scenario: string) => {
        if (data === undefined) {
            return { score: 0.0, message_fail: '', message_success: '', style: '' }
        }

        const final = data.final;
        const successObjectives = data.successObjectives;
        const failedObjectives = data.failedObjectives;

        const topAchieved = this.getBottomAdjectives(successObjectives, 3, undefined);
        const notAchieved = this.getTopAdjectives(failedObjectives, 3, undefined);

        const message = <div>
            <Card interactive={false} elevation={Elevation.ZERO}>
                <h5>What Went Well</h5>
                <ul>
                    {topAchieved}
                </ul>
            </Card>

            <Card interactive={false} elevation={Elevation.ZERO}>
                <h5>What To Try Next Time</h5>
                <ul>
                    {notAchieved}
                </ul>
            </Card>
        </div>

        return {
            score: final,
            message_success: message,
            message_fail: message,
            style: this.convertScenarioToStyle(scenario)
        }
    }

    renderSimulatedSectionConfig = (config: any) => {
        if (config === undefined) return <span><h5>No coaching could be found for this play.</h5></span>

        const pass = parseFloat(config.score) >= 65.0;

        const message = pass ? config.message_success : config.message_fail;

        return <div>
            {message}
        </div>
    }

    renderConstructiveFeedback = () => {
        const {
            simulatedData,
            loadingSimulated
        } = this.state;

        let innards = <Spinner />

        if (loadingSimulated === false) {
            const scenario = this.props.menuConfig.slug.replace("classic_", "");
            const section = this.renderSimulatedSection(simulatedData.coaching[scenario], scenario);

            innards = <span>
                {this.renderSimulatedSectionConfig(section)}
            </span>
        }

        return <span style={{ flexGrow: 1, flexBasis: 0 }}>
            <span style={{ flexShrink: 1, transition: 'all 2s' }}>
                <span style={{ position: 'relative' }}>
                    {innards}
                </span>
            </span>
        </span>
    }

    renderDisplay = () => {
        const {
            showCharts,
            showScore,
            showCoaching
        } = this.state;

        const chartData = this.getChartData();

        const {
            savedPreJournal
        } = this.props;

        if (showCharts === true) {
            return <span className="resultsClassicGraph" style={{ flexGrow: 1, flexBasis: 0 }}>
                <div style={{ display: 'block', height: '100%' }}>
                    <ReactHighcharts containerProps={{ style: { height: "100%" } }} highcharts={Highcharts} options={chartData} />
                </div>
            </span>
        }

        if (showScore) {
            return this.renderScoreDisplay();
        }

        if (showCoaching) {
            return this.renderConstructiveFeedback();
        }

        // Show the user what they entered as there plan
        return <span style={{ flexGrow: 1, flexBasis: 0 }}>
            <span style={{ flexShrink: 1, transition: 'all 2s' }}>
                <span style={{ position: 'relative' }}>
                    <H4>{translateKey('vleader.yourJournal')}</H4>
                    <TextAreaV2 defaultValue={savedPreJournal} value={savedPreJournal} readOnly={true} className={"journalTextArea"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2>
                </span>
            </span>
        </span>
    }

    renderControls = () => {
        const {
            isJournalVisible
        } = this.state;

        const mainControlButtons = [
            this.renderScoreHappenedButton(),
            this.renderReflectOnWhatHappenedButton(),
            this.renderReadYourOriginalPlanButton(),
            this.renderResumeButton()
        ]

        return <span style={{ flexGrow: 0 }}>
            <span style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right', float: 'right' }}>
                {isJournalVisible ? undefined : mainControlButtons}
            </span>
        </span>
    }

    render() {
        const {
            loadingObjectiveData
        } = this.state;

        const journalDrawer = <Drawer
            onClose={() => {
                this.setState({
                    isJournalVisible: false
                })
            }}
            isOpen={this.state.isJournalVisible}
            position={Position.BOTTOM}
            canOutsideClickClose={true}
            canEscapeKeyClose={true}
            usePortal={false}
            autoFocus={true}
            enforceFocus={true}
            title="vLeader Journal"
        >
            <div className={Classes.DRAWER_BODY}>
                <div className={Classes.DIALOG_BODY}>
                    {this.renderJournal()}
                </div>
            </div>
            <div className={Classes.DRAWER_FOOTER}>
                <p style={{ float: 'left' }}>Your instructor can use this to help and guide you.</p>
                <Button intent={Intent.PRIMARY} style={{ float: 'right' }} onClick={() => {
                    this.setState({
                        isJournalVisible: false
                    })
                }}>Done</Button>
                <div className="clearfix" />
            </div>
        </Drawer>

        if (loadingObjectiveData) {
            return <span style={{ display: 'block', width: '100%', height: '100%' }}>
                <span style={{ display: 'block', width: '200px', height: '300px', margin: 'auto', marginTop: '100px' }}>
                    <H4 style={{ textAlign: 'center', marginBottom: '40px' }}>{translateKey('vleader.loading')}</H4>
                    <Spinner />
                </span>
            </span>
        }

        return <span style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
            {journalDrawer}
            {this.renderAudio()}
            {this.renderControls()}
            {this.renderDisplay()}
            <div className="clearfix" />
        </span>
    }
}
